/**************************************************
 * Nombre:       Tarjeta_Banner_Verde
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {KeyboardArrowRight} from "@mui/icons-material";
import fondo from '../../Recursos/fondo_banner_verde.svg'
import tempo from '../../Recursos/tmp_banner_verde.png'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../Utilidades/irUrl";


const Tarjeta_Banner_Verde = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                p: 0,
                height: !masSM ? 230 : 280,
                overflow: 'hidden',
            }}
        >

            <Grid container size={{xs: 9, sm: 9, md: 4}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{color: '#fff', px: 4}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: sCell ? 10 : 12, fontWeight: 600}}>{item.subTituloUno}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                color: theme.palette.secondary.main,
                                fontSize: sCell ? 40 : 48,
                                fontWeight: 700,
                                lineHeight: 1.1
                            }}
                        >{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 16, fontWeight: 700}}>
                            {item.subTituloDos}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3, mb: 1}}>
                        <Button
                            onClick={() => irUrl(item.link)}
                            color={'secondary'} sx={{px: 1, backgroundColor: '#6839CC', py: 0.8}}>
                            <Typography sx={{px: 2, fontSize: 14}}>
                                Ver Mas
                            </Typography>
                            <IconButton
                                sx={{backgroundColor: '#fff', p: 0.2}}><KeyboardArrowRight/></IconButton></Button>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 3, sm: 3, md: 8}}
                  sx={{justifyContent: 'flex-start', ml: !masSM ? -12 : 0, mb: -10}}>
                <img src={tempo} width={!masSM ? '350%' : '100%'} height={'auto'}/>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Banner_Verde